import { hydrateRoot } from 'react-dom/client';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { RelayEnvironmentProvider } from 'react-relay';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import { DibsWeb3ReactProvider } from 'dibs-crypto-utils/exports/DibsWeb3ReactProvider';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { ServerVarsContextProvider } from '../utils/ServerVarsContext';
import { NftHeaderLayout } from '../nftHeader/NftHeaderLayout';
import { trackPageview } from 'dibs-tracking';

import { paths } from '../nftPublicProfile/constants';
import { NftPublicProfileRespLayout } from '../nftPublicProfile/profile/NftPublicProfileRespLayout';
import { nftPublicProfileEntryQuery } from '../nftPublicProfile/profile/nftPublicProfileEntryQuery';

import { type NftHeaderLayout_viewer$key as NftHeaderLayoutViewer } from '../nftHeader/__generated__/NftHeaderLayout_viewer.graphql';
import { type NftPublicProfileRespLayout_viewer$key as NftPublicProfileViewer } from '../nftPublicProfile/profile/__generated__/NftPublicProfileRespLayout_viewer.graphql';

const locale = serverVars.get('locale');
const environment = getRelayEnvironment({
    ...serverVars.get('dbl.relayData'),
    ...serverVars.get('relay.relayData'),
});

const variables = serverVars.get('relay.variables');

const operation = createOperationDescriptor(getRequest(nftPublicProfileEntryQuery), variables);
const snapshot = environment.lookup(operation.fragment);
environment.retain(operation);

initializeDBL().then(({ store }: { store: $TSFixMe }) => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <IntlProvider locale={locale}>
            <ServerVarsContextProvider
                isMobile={serverVars.get('settings.isMobile')}
                isTablet={serverVars.get('settings.isTablet')}
                isDesktop={serverVars.get('settings.isDesktop')}
            >
                <RelayEnvironmentProvider environment={environment}>
                    <ErrorBoundary fallback={({ error }) => <Error500Layout error={error} />}>
                        <Router basename={`${paths.profileUser}${variables?.username}`}>
                            <Provider store={store}>
                                <DibsWeb3ReactProvider>
                                    <NftHeaderLayout
                                        viewer={snapshot.data.viewer as NftHeaderLayoutViewer}
                                    >
                                        <NftPublicProfileRespLayout
                                            viewer={snapshot.data.viewer as NftPublicProfileViewer}
                                        />
                                    </NftHeaderLayout>
                                </DibsWeb3ReactProvider>
                            </Provider>
                        </Router>
                    </ErrorBoundary>
                </RelayEnvironmentProvider>
            </ServerVarsContextProvider>
        </IntlProvider>
    );
    trackPageview({
        additional: {
            pageType: 'Results',
            pageSubType: 'NFT Profile',
        },
    });
});
